import { setError } from "../redux/slices/ErrorSlice";
import { store } from "../redux/store";

export const handleError = (error: any) => {
  let title = "Error";
  let message = "An unexpected error occurred.";
  let shouldLogout = false;
  let shouldGoBack = false;

  if (error.response) {
    const errorCode = error.response.status;

    switch (errorCode) {
      case 400:
        title = "Bad Request";
        shouldGoBack = false;
        break;
      case 401:
        title = "Authentication Error";
        shouldLogout = true;
        break;
      case 403:
        title = "Access Denied";
        shouldGoBack = true;
        break;
      case 404:
        title = "Not Found";
        shouldGoBack = false;
        break;
      case 429:
        title = "Too Many Requests";
        break;
      case 500:
        title = "Internal Server Error";
        shouldGoBack = true;
        break;
      default:
        title = "Unknown Error";
        shouldLogout = true;
        break;
    }

    message = error.response.data?.message;
  } else if (error.message) {
    message = error.message;
  }

  store.dispatch(
    setError({ error: { title, message, shouldLogout, shouldGoBack } })
  );
};
